<template>
  <b-sidebar
    id="sidebar"
    no-header
    no-header-close
    no-close-on-backdrop
    no-close-on-esc
    no-close-on-route-change
    class="mc-sidebar-liveview mc-sidebar-trackvideo"
    :class="{
      'close-history-sidebar': $store.state.map.modalFleetHistory === true,
      '': $store.state.map.modalFleetHistory === false,
    }"
  >
    <span class="mc-sidebar-toggle mc-sidebar-trackvideo__toggle" @click="toggleSideBar">
      <i class="mc-fa fas fa-angle-left"></i>

      <u></u>
    </span>

    <div class="mc-sidebar-liveview__wrapper mc-sidebar-trackvideo__wrapper">
      <template v-if="!isHasAccessSwitchView">
        <ListFleetV2 v-if="hasAccess(['b3l-trackvision-new-video-status:read'])" ref="listFleet" />
        <ListFleet v-else ref="listFleet" />
      </template>
      <template v-else>
        <ListFleetV2 v-if="isNewView" ref="listFleet" />  
        <ListFleet v-else ref="listFleet" />
      </template>
    </div>
  </b-sidebar>
</template>

<script>
import { mapGetters } from 'vuex'
import ListFleetV2 from './Fleets/ListFleetV2'
import ListFleet from './Fleets/ListFleet'
import responsive from '@/mixin/responsive'

export default {
  name: 'SideBar',
  components: {
    ListFleet,
    ListFleetV2,
  },
  mixins: [responsive],
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    isHasAccessSwitchView() {
      return this.hasAccess(['b3n-trackvision-toggle-video-status:read'])
    },
    isNewView () {
      const isNewView = JSON.parse(localStorage.getItem('live-streaming-switch-view-on')) ?? true
      return isNewView
    }
  },
  created() {
    if (this.mediaQuery.matches && this.$store.state.sidebar.sideBarOpen) {
      this.toggleSideBar()
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.commit('sidebar/toggleSideBar')
      if (this.mediaQuery.matches) {
        this.$store.dispatch('map/closeInfo', false)
      }
    },
  },
}
</script>
